import { render } from "./InfoAccionista_Natural.vue?vue&type=template&id=2b1f43cf&ts=true"
import script from "./InfoAccionista_Natural.vue?vue&type=script&lang=ts"
export * from "./InfoAccionista_Natural.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__